<script>
  import { imgSrc, Draggable, Button } from '$client';
  import { onMount } from 'svelte';
  export let data;

  const calcPos = (boxSize, elSize) => {
    const available = boxSize - elSize;
    return Math.random() * available;
  };

  const moveItems = (box, items) => {
    let timer = null;
    return () => {
      if (timer) timer = (clearTimeout(timer), null);
      timer = setTimeout(() => {
        const { width: boxWidth, height: boxHeight } = box.getBoundingClientRect();
        for (var item of items) {
          if (item.classList.contains('cleaned-game-item')) {
            if (item.style.top === 0) continue;
            item.style.top = 0;
            item.style.left = 0;
            continue;
          }
          var { width: elWidth, height: elHeight } = item.getBoundingClientRect();
          item.style.left = `${calcPos(boxWidth, elWidth)}px`;
          item.style.top = `${calcPos(boxHeight, elHeight)}px`;
        }
      }, 250);
    };
  };

  const DELTA = 0;
  const onMove = (_, moveable) => {
    const target = document.getElementsByClassName('game-target')[0];
    const { left: targetX, top: targetY, width: targetWidth, height: targetHeight } = target.getBoundingClientRect();
    const { left, top, width: itemWidth, height: itemHeight } = moveable.getBoundingClientRect();
    const [right, bottom] = [left + itemWidth, top + itemHeight];

    const DROP_ZONE = {
      minX: targetX - DELTA,
      maxX: targetX + targetWidth + DELTA,
      maxY: targetY + targetHeight + DELTA,
      minY: targetY - DELTA,
    };

    const WEST = DROP_ZONE.minX <= left && left <= DROP_ZONE.maxX;
    const NORTH = DROP_ZONE.minY <= top && top <= DROP_ZONE.maxY;
    const EAST = DROP_ZONE.minX <= right && right <= DROP_ZONE.maxX;
    const SOUTH = DROP_ZONE.minY <= bottom && bottom <= DROP_ZONE.maxY;

    if ((WEST || EAST) && (NORTH || SOUTH)) {
      moveable.classList.add('cleaned-game-item');
      victory();
    }
  };

  const victory = () => {
    const items = [...document.getElementsByClassName('game-item')];
    if (items.every(item => item.classList.contains('cleaned-game-item'))) {
      const container = document.getElementsByClassName('game-spawn-items')[0];
      container.classList.add('game-victory');
    }
  };

  const reset = () => {
    const box = document.getElementsByClassName('game-spawn-items')[0];
    const items = [...document.getElementsByClassName('game-item')];
    items.forEach(item => item.classList.remove('cleaned-game-item'));
    const move = moveItems(box, items);
    move();
    box.classList.remove('game-victory');
  };

  const autoWin = () => {
    const items = [...document.getElementsByClassName('game-item')];
    items.forEach(item => item.classList.add('cleaned-game-item'));
    const container = document.getElementsByClassName('game-spawn-items')[0];
    container.classList.add('game-victory');
  };

  onMount(() => {
    const items = [...document.getElementsByClassName('game-item')];
    const box = document.getElementsByClassName('game-spawn-items')[0];
    const move = moveItems(box, items);
    window.addEventListener('resize', move), move();
    return () => {
      window.removeEventListener('resize', move);
    };
  });
</script>

<section class="container">
  <header class="game-header">
    <h2 class="h2">{@html data.header}</h2>
    <img src={imgSrc(data.help.data.attributes.url)} alt={data.help.data.attributes.alternativeText} loading="lazy" />
  </header>
  <div class="game">
    <img
      height="242"
      width="511"
      class="game-target"
      src={imgSrc(data.target.data.attributes.url)}
      alt={data.target.data.attributes.alternativeText}
      loading="lazy" />
    <div class="game-spawn-items">
      {#each data.items.data as { attributes: item }}
        <Draggable {onMove} attributes={{ class: 'game-item' }}>
          <img
            draggable="false"
            height={Math.min(300, item.width)}
            width={Math.min(300, item.width)}
            src={imgSrc(item.url)}
            alt={item.alternativeText}
            loading="lazy" />
        </Draggable>
      {/each}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <!-- svelte-ignore a11y-no-static-element-interactions -->
      <div class="game-auto-win" on:click={autoWin}>
        <button type="button">
          Сложить вещи
          <img
            height="40"
            width="40"
            src={imgSrc('/uploads/touch_app_be8a2d8825.svg')}
            alt="Сложить вещи автоматически" />
        </button>
      </div>
    </div>
    <section class="game-finish">
      <div>
        <h3>{@html data.finishHeader}</h3>
        <p>{@html data.finishDescription} <br /> <span>{data.code}</span></p>
        <Button title={data.button.header} action={data.button.modal} />
        <Button type="transparent-black" title="Сложить еще раз" action={reset} />
      </div>
    </section>
  </div>
</section>

<style lang="scss">
  section {
    display: flex;
    flex-direction: column;
    gap: 20px;
    background-color: #30d09f;
    padding-block: 50px;

    @media only screen and (max-width: 1499.98px) {
      padding-block: 40px;
    }

    @media only screen and (max-width: 767.98px) {
      padding-block: 30px;
    }
  }

  h2 {
    min-width: max(50%, 300px);
    color: #fff;
    font-weight: 800;
    font-family: Vela Sans;
  }

  header {
    display: inline-flex;
    justify-content: space-between;

    @media only screen and (max-width: 991.98px) {
      flex-direction: column;
      gap: 20px;
      align-items: center;
      justify-content: flex-start;

      img {
        width: 100%;
      }
    }
  }

  .game {
    display: inline-flex;
    gap: 20px;
    margin-top: 20px;
    user-select: none;

    @media only screen and (max-width: 991.98px) {
      flex-direction: column;
      gap: 0 !important;
      align-items: center;
      justify-content: center;
    }

    &:has(.game-item:active) {
      .game-target {
        transform: scale(1.05);
      }
    }
  }

  .game-auto-win {
    display: none;
  }

  @media only screen and (max-width: 991.98px) {
    .game-target,
    .game-header img {
      display: none;
    }

    .game-auto-win {
      position: absolute;
      z-index: 5;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;

      button {
        padding: 0 8px 0 16px;
        color: #2c333c;
        font-size: 16px;
        font-family: Roboto;
        background: #fff;
        border-radius: 5px;
      }
    }
  }

  :global(.cleaned-game-item) {
    transform: scale(0) !important;
    transition: transform 0.4s;
  }

  .game-target {
    max-width: max(40%, 300px);
    transition: 0.5s;
    will-change: scale;

    @media only screen and (max-width: 991.98px) {
      max-width: 100%;
    }
  }

  .container:has(.game-victory) {
    .game-spawn-items,
    .game-header img {
      display: none;
    }

    .game-target {
      display: none;
    }

    .game {
      gap: 40px;
    }

    .game-finish {
      display: flex;
    }
  }

  .game-finish {
    position: relative;
    z-index: 5;
    display: none;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 40px 10px;
    color: #2c333c;
    text-align: center;
    background: #fff;
    border-radius: 16px;

    div {
      display: flex;
      flex-direction: column;
      gap: 15px;
      max-width: 332px;
    }

    h3 {
      font-weight: 800;
      font-size: 20px;
      font-family: Vela Sans;
      line-height: 26px;
    }

    p {
      margin-bottom: 15px;
      font-weight: normal;
      font-size: 16px;
      font-family: Roboto;
      line-height: 22px;
    }

    span {
      font-weight: 800;
      font-size: 16px;
      font-family: Roboto;
    }
  }

  .game-spawn-items {
    position: relative;
    min-width: max(60%, 300px);

    &::before {
      position: absolute;
      width: 100%;
      height: 100%;
      background: #bff0e175;
      content: '';
      clip-path: ellipse(50% 25% at 50% 75%);
    }

    @media only screen and (min-width: 991.98px) {
      min-height: 100%;
    }

    @media only screen and (max-width: 991.98px) {
      width: 100%;
      min-height: 225px;
    }

    @media only screen and (max-width: 767.98px) {
      min-height: 175px;
    }
  }

  :global(.game-item) {
    position: absolute;
    z-index: 4;
    transition: transform 0.5s;
    will-change: scale;

    &:hover {
      transform: scale(1.05);
    }
  }
</style>
